// extracted by mini-css-extract-plugin
export default {"widget":"MobileWidget_widget__1LRlX","widget__list":"MobileWidget_widget__list__W0Ksb","item":"MobileWidget_item__uE-s7","item__icon":"MobileWidget_item__icon__igEdb"};